const number = (value) => {
  if (isNaN(value)) return '';

  const num = Number(value);

  // Check if the number has decimal places
  if (num % 1 !== 0) {
    // Has decimal places - format to 2 decimal places
    return num.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  } else {
    // Is an integer - format without decimal places
    return num.toLocaleString('en');
  }
};
const capitalize = (value) => {
  if (!value) {
    return '';
  }
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
};

export default {
  install(app) {
    app.filter('number', number);
    app.filter('capitalize', capitalize);
  }
};
